<template>
  <div>
    <b-row>
      <b-col cols="12">
        <hr>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <div class="form-group">
              <label for="value">{{$t("views.agreements.form.advanceValue")}}:</label>
              <input v-model="payment.value" name="value" type="text" required autofocus :placeholder="$t('views.agreements.form.advanceValue')" class="form-control" id="value"/>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group">
              <label>{{$t("tableHeadings.agreement")}}:</label>
              <model-select v-model="payment.idAgreement" name="idAgreement" :isDisabled="disabled" :options="idAgreementOptions" :placeholder="$t('tableHeadings.agreement')" class="">
              </model-select>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
          <div v-if="display && agreement">
            <b><p class="mb-0 p-0 pl-1 text-danger"><i class="fal fa-exclamation"></i> {{agreement.comment}}</p></b>
            <b><p class="mb-0 p-0 pl-1"><i class="fal fa-file"></i> {{$t('views.exsbpaymentsmade.list.agreement')}} - {{agreement.agreementNumber}} {{$t("global.nameAndSurname")}}: {{ agreement.idClient.name }} {{ agreement.idClient.surname }}, {{$t("views.userdata.form.firmname1")}}: {{ agreement.idClient.firmname1 }} {{ agreement.idClient.firmname2 }}, {{$t("views.agreements.show.debt")}}: {{ agreement.debtValue }}<span v-if="agreement.applicationName">, {{$t('views.application.show.title')}} {{agreement.applicationName}}</span></p></b>
            <b-row>
              <b-col class="p-1 pl-4">
                <p class="mb-1" v-if="!agreement.sourceAccount">{{$t('views.agreements.show.noSourceAccount')}}</p>
                <p class="mb-1" v-if="agreement.sourceAccount">{{$t('views.agreements.show.sourceAccount')}}: <b>{{agreement.sourceAccount}}</b></p>
<!--                <p class="mb-1">-->
<!--                  <span>{{$t('views.agreements.show.paymentsRequired')}}: </span>-->
<!--                  <b>{{agreement.balance.paymentsSum}} {{$t('currency')}}</b>-->
<!--                </p>-->
<!--                <p class="mb-1">-->
<!--                  <span>{{$t('views.agreements.show.paymentsMade')}}: </span>-->
<!--                  <b v-if="agreement.balance.paymentsMadeSum">{{agreement.balance.paymentsMadeSum}} {{$t('currency')}}</b>-->
<!--                  <b v-if="!agreement.balance.paymentsMadeSum">0 {{$t('currency')}}</b>-->
<!--                </p>-->
<!--                <p class="mb-1">-->
<!--                  <span>{{$t('views.agreements.show.balance')}}: </span>-->
<!--                  <b v-bind:class="{'text-danger': agreement.balance.paymentsMadeSum - agreement.balance.paymentsSum < 0, 'text-success': agreement.balance.paymentsMadeSum - agreement.balance.paymentsSum > 0}">-->
<!--                    {{(agreement.balance.paymentsMadeSum - agreement.balance.paymentsSum).toFixed(2)}} {{$t('currency')}}-->
<!--                  </b>-->
<!--                </p>-->
              </b-col>
            </b-row>
          </div>
        </transition>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="index === 0 && paymentMade.typeMassCollect !== 1">
        <div class="form-group">
          <b-form-checkbox class="float-left" id="addAccountToAgreement"
                           v-model="payment.addAccountToAgreement"
                           name="addAccountToAgreement"
                           :value="1"
                           :unchecked-value="0">
            {{$t("views.exsbpaymentsmade.form.addAccountToAgreement")}}
          </b-form-checkbox>
          <b-btn class="float-left ml-3" @click="removeAgreementFromPayment(payment)" variant="info" v-if="payment.idAgreement">{{$t('buttons.removeAgreementFromPayments')}}</b-btn>
        </div>
      </b-col>
      <b-col>
        <b-btn class="btn btn-danger float-right" @click="removePayment(index)">{{$t('buttons.delete')}}</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import ApiService from '@/utils/ApiService'

export default {
  name: 'OtherAgreement',
  components: {
    ModelSelect
  },
  watch: {
    'payment.value': function (val) {
      this.$emit('changeSingleValue', val)
    },
    'payment.idAgreement': function (val) {
      if (val) {
        if (this.payment.autoAdd === 1) {
          this.disabled = true
        } else {
          this.disabled = false
        }
        this.fetchAgreement(val, 0)
      }
    }
  },
  data () {
    return {
      agreement: null,
      display: true,
      disabled: true
    }
  },
  created () {
    this.fetchAgreement(this.payment.idAgreement)
    if (this.payment.agreement && this.payment.autoAdd === 1) {
      this.agreement = Object.assign({}, this.payment.agreement)
      delete this.payment.agreement
    } else {
      this.disabled = false
    }
  },
  props: {
    removePayment: {
      type: Function,
      required: true
    },
    payment: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    idAgreementOptions: {
      type: Array,
      required: true
    },
    paymentMade: {
      type: Object,
      required: true
    }
  },
  methods: {
    async fetchAgreement (id) {
      if (id) {
        this.agreement = null
        this.agreement = await new ApiService(id).getResults()
      }
    },
    async removeAgreementFromPayment (payment) {
      const response = await new ApiService(`e_x_s_b_payments_mades/${payment.idPayment}/removeagreementfrompayment`).put({})
      if (response.status === 200) {
        this.payment.idAgreement = null
        this.agreement = null
      }
    }
  }
}
</script>
